import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth-context';
import { t } from '../../i18n';
import { AppShell } from '../shared/AppShell';
import { Button } from '../shared/Button';

type State = {
  completed_surah: { number: number; name_uz: string; name_ar: string };
  next_surah: { number: number; name_uz: string; name_ar: string } | null;
  total_recitations_for_surah: number;
  days_spent_on_surah: number;
};

export function SurahComplete() {
  const navigate = useNavigate();
  const location = useLocation();
  const { state: auth } = useAuth();
  const data = location.state as State | null;
  const child = auth.status === 'child' ? auth.child : null;

  if (!data) {
    navigate('/child', { replace: true });
    return null;
  }

  return (
    <AppShell ramp={child?.color_ramp}>
      <main className="mx-auto flex min-h-dvh max-w-md flex-col items-center justify-center gap-6 p-8 text-center">
        <div
          className="font-arabic text-[56px] leading-none text-ink"
          dir="rtl"
        >
          {data.completed_surah.name_ar}
        </div>
        <div className="text-[18px] font-medium text-ink-muted">
          {data.completed_surah.name_uz}
        </div>
        <p className="text-[16px] leading-relaxed">
          {t('surah.complete.title', { surah: data.completed_surah.name_uz })}
        </p>
        <p className="text-[12px] text-ink-subtle">
          {t('surah.complete.stats', {
            days: data.days_spent_on_surah,
            n: data.total_recitations_for_surah,
          })}
        </p>
        <Button childColor onClick={() => navigate('/child', { replace: true })}>
          {t('common.continue')}
        </Button>
      </main>
    </AppShell>
  );
}
